export function ChangeIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_333_3447)">
        <circle cx="9" cy="9" r="9" fill="black" fill-opacity="0.3" />
        <path d="M14.1 5.1001H7.49998C5.27201 5.1001 3.59998 6.71112 3.59998 9.0001" stroke="white" stroke-width="1.26" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M3.8999 12.9H10.4999C12.7279 12.9 14.3999 11.289 14.3999 9" stroke="white" stroke-width="1.26" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12.8999 3.59998C12.8999 3.59998 14.3999 4.70471 14.3999 5.09999C14.3999 5.49527 12.8999 6.59998 12.8999 6.59998" stroke="white" stroke-width="1.26" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5.09996 11.4C5.09996 11.4 3.59998 12.5047 3.59998 12.9C3.59997 13.2953 5.09998 14.4 5.09998 14.4" stroke="white" stroke-width="1.26" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_333_3447">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

ChangeIcon.displayName = 'ChangeIcon';
